import styled from 'styled-components';
import DefaultTab from 'components/Tab';
import DefaultButton from 'components/Buttons/Button';
import StickyHeader from 'components/StickyHeader';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Header = styled(StickyHeader)``;

// TODO: TFR-44 move to container group
export const Tabs = styled.nav`
  display: flex;
`;

// TODO: TFR-44 move to container group
export const Tab = styled(DefaultTab)`
  :not(:last-child) {
    margin-right: 1rem;
  }
`;

// TODO: TFR-44 move to container group
export const Filters = styled.div`
  display: flex;
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  margin-left: 1rem;
`;
